import React from "react";
// Import des components de la home
import Pagebanner from './pagebanner';
import About from './about';
import Timeline from './timeline';
import Realisations from './realisations';
import Form from './form';

const Home = () => {
    return (
        <main className="home">
            <Pagebanner />
            <About />
            <Timeline />
            <Realisations />
            <Form />
        </main>
    )
};

export default Home;